document.addEventListener('DOMContentLoaded', function() {
    const infoButtons = document.querySelectorAll('.package-protection__info');
    const popup = document.getElementById('packageInfoPopup');
    const overlay = document.getElementById('overlay');
    const closeBtn = document.querySelector('.close-btn');
    const checkboxes = document.querySelectorAll('.choice_toggle');
    const checkoutButtons = document.querySelectorAll('.checkout-package-protection');
    const packageProtectionProductID = window.packageProtectionProductID;

    // Spinner SVG (you can replace this with your actual SVG code or an <img> tag pointing to a spinner image)
    const spinnerSVG = `<svg fill="#ffffff" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_qM83{animation:spinner_8HQG 1.05s infinite}.spinner_oXPr{animation-delay:.1s}.spinner_ZTLf{animation-delay:.2s}@keyframes spinner_8HQG{0%,57.14%{animation-timing-function:cubic-bezier(0.33,.66,.66,1);transform:translate(0)}28.57%{animation-timing-function:cubic-bezier(0.33,0,.66,.33);transform:translateY(-6px)}100%{transform:translate(0)}}</style><circle class="spinner_qM83" cx="4" cy="12" r="3"/><circle class="spinner_qM83 spinner_oXPr" cx="12" cy="12" r="3"/><circle class="spinner_qM83 spinner_ZTLf" cx="20" cy="12" r="3"/></svg>`;

    // Show popup and overlay on button click
    infoButtons.forEach(infoButton => {
        infoButton.addEventListener('click', () => {
            overlay.style.display = 'block';
            popup.style.display = 'block';
            setTimeout(() => {
                overlay.classList.add('visible');
                popup.classList.add('visible');
            }, 10); 
        });
    });

    // Close popup and overlay when the close button is clicked
    closeBtn.addEventListener('click', () => {
        overlay.classList.remove('visible');
        popup.classList.remove('visible');
        setTimeout(() => {
            overlay.style.display = 'none';
            popup.style.display = 'none';
        }, 300); 
    });

    // Close popup and overlay if user clicks outside the popup
    window.addEventListener('click', (event) => {
        if (event.target == overlay) {
            overlay.classList.remove('visible');
            popup.classList.remove('visible');
            setTimeout(() => {
                overlay.style.display = 'none';
                popup.style.display = 'none';
            }, 300); 
        }
    });

    // Initialize localStorage if not already set
    let savedState = localStorage.getItem('packageProtectionChecked');
    if (savedState === null) {
        savedState = 'true'; // Default to true since the checkbox is checked by default
        localStorage.setItem('packageProtectionChecked', savedState);
    }

    // Apply the saved state to all checkboxes
    checkboxes.forEach(checkbox => {
        checkbox.checked = savedState === 'true';

        // Listen for changes on each checkbox and update localStorage
        checkbox.addEventListener('change', function() {
            localStorage.setItem('packageProtectionChecked', checkbox.checked);
            checkboxes.forEach(cb => cb.checked = checkbox.checked);
        });
    });

    // Function to remove the package protection product from the cart
    function removePackageProtectionFromCart() {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const item = cart.items.find(item => item.id === parseInt(packageProtectionProductID));
            if (item) {
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: item.key,
                        quantity: 0
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Package protection product removed from cart:', data);
                })
                .catch((error) => {
                    console.error('Error removing package protection product from cart:', error);
                });
            }
        })
        .catch((error) => {
            console.error('Error fetching cart:', error);
        });
    }

    // Remove package protection product on every page load
    removePackageProtectionFromCart();

    // Handle checkout button clicks
    checkoutButtons.forEach(button => {
        button.addEventListener('click', function(event) {
            const isChecked = localStorage.getItem('packageProtectionChecked') === 'true';

            // Replace button text with spinner
            button.innerHTML = spinnerSVG;

            if (isChecked) {
                event.preventDefault(); 

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: packageProtectionProductID,
                        quantity: 1
                    })
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Package protection product added to cart:', data);
                    // Delay before redirecting to checkout to ensure the add to cart request is processed
                    setTimeout(() => {
                        window.location.href = '/checkout';
                    }, 500); // Adjust the delay time as needed
                })
                .catch((error) => {
                    console.error('Error adding package protection product to cart:', error);
                    window.location.href = '/checkout'; // Proceed to checkout even if there's an error
                });
            } else {
                window.location.href = '/checkout';
            }
        });
    });
});
